<p-table [value]="rows">
  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'instrumentLastUpdated.table.datasource' | transloco }}</th>
      <th>{{ 'instrumentLastUpdated.table.status' | transloco }}</th>
      <th>{{ 'instrumentLastUpdated.table.lastUpdated' | transloco }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td>{{ rowData.source === 'autocheck' ? ( 'instrument.widget.autocheck' | transloco ) : rowData.source === 'maintenance' ? ( 'instrument.widget.maintenance' | transloco ) : rowData.source === 'qcIssues' ? ( 'instrument.widget.qcIssues' | transloco ) : rowData.source === 'errorEvents' ? ( 'instrument.widget.errorEvents' | transloco ) : rowData.source }}</td>
      <td>
        <sh-icon [ngClass]="rowData.status === 'confirmation' ? 'confirmation' : 'none'" id="status-icon" icon="{{ rowData.status }}" size="xs"></sh-icon>
        @if (rowData.status === 'confirmation') {
          <sh-tooltip id="instrument-last-updated-tooltip-1" style="width: 210px;" target="status-icon">{{ 'instrumentLastUpdated.tooltip.noMachineData' | transloco }}</sh-tooltip>
        }
        @if (!moduleTypeValid.includes(rowData.moduleType.toLowerCase()) && rowData.source === 'qcIssues' && rowData.status === 'confirmation') {
          <sh-tooltip id="instrument-last-updated-tooltip-2" style="width: 210px;" target="status-icon">{{ 'instrumentLastUpdated.tooltip.qcOnlyAtellica' | transloco }}</sh-tooltip>
        }

      </td>
      <td>{{ !rowData.lastUpdated ? '-' : (rowData.lastUpdated) }}</td>
    </tr>
  </ng-template>
</p-table>